import { z } from "zod";

// Website form client data schema
export const WebsiteIntakeFormClientSchema = z.object({
  cuid: z.number().nullable().optional(),
  cadate: z.string().nullable().optional(),
  ctype: z.string().nullable().optional(),
  cstatus: z.string().nullable().optional(),
  clientstatus: z.string().nullable().optional(),
  ccomp: z.string().nullable().optional(),
  caddr1: z.string().nullable().optional(),
  caddr2: z.string().nullable().optional(),
  ccity: z.string().nullable().optional(),
  cst: z.string().nullable().optional(),
  czip: z.number().nullable().optional(),
  cphone: z.number().nullable().optional(),
  caltphone: z.number().nullable().optional(),
  csmsphone: z.number().nullable().optional(),
  cext: z.string().nullable().optional(),
  cfax: z.number().nullable().optional(),
  ccontact: z.string().nullable().optional(),
  ctitle: z.string().nullable().optional(),
  cemail: z.string().nullable().optional(),
  ccontact2: z.string().nullable().optional(),
  ctitle2: z.string().nullable().optional(),
  cphone2: z.number().nullable().optional(),
  cext2: z.string().nullable().optional(),
  cemail2: z.string().nullable().optional(),
  cnotes: z.string().nullable().optional(),
  cview: z.string().nullable().optional(),
  creferral: z.string().nullable().optional(),
  ccontactmeth: z.string().nullable().optional(),
});

// Website form building data schema
export const WebsiteIntakeFormBuildingSchema = z.object({
  badate: z.string().nullable().optional(),
  bcontact: z.string().nullable().optional(),
  bcontactphone: z.string().nullable().optional(),
  bcontactemail: z.string().nullable().optional(),
  btype: z.string().nullable().optional(),
  bfloors: z.number().nullable().optional(),
  bname: z.string().nullable().optional(),
  baddr1: z.string().nullable().optional(),
  baddr2: z.string().nullable().optional(),
  bcity: z.string().nullable().optional(),
  bst: z.string().nullable().optional(),
  bzip: z.number().nullable().optional(),
  bview: z.string().nullable().optional(),
});

// Main website form schema
export const WebsiteIntakeFormSchema = z.object({
  client: WebsiteIntakeFormClientSchema,
  building: WebsiteIntakeFormBuildingSchema,
});

// Type definitions
export type WebsiteIntakeFormClient = z.infer<typeof WebsiteIntakeFormClientSchema>;
export type WebsiteIntakeFormBuilding = z.infer<typeof WebsiteIntakeFormBuildingSchema>;
export type WebsiteIntakeForm = z.infer<typeof WebsiteIntakeFormSchema>; 